import fp from "lodash/fp";

import { mapSoftwareOptionsGeneralData } from "hooks";

export default function mapSoftwareOptionsGeneralForm(formValues) {
	if (fp.isEmpty(formValues)) return;
	const mappedValues = {
		softwareOptionDefaults: mapSoftwareOptionsGeneralData(formValues),
	};

	return mappedValues;
}
